var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"primary px-2 py-2",attrs:{"small":_vm.dense},on:{"click":function($event){$event.stopPropagation();return _vm.openChatPanel.apply(null, arguments)}}},[_c('v-icon',{staticClass:"pr-2"},[_vm._v("mdi-chat-outline")]),_vm._v("\n  "+_vm._s(_vm.unreadIndicator)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }